import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import { NotifyService } from "../services/notify-service";
import { AlertService } from "../services/alert-service";
import { EntityService } from "../services/entity-service";

export function RLViewAddAlertToCharacteristic() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/view-add-alert-to-characteristic.html"),
        controller: RLViewAddAlertToCharacteristicController,
        controllerAs: "avVM",
        bindToController: true,
        scope: {
            charTypeID: "=charTypeId",
            templateID: "=templateId",
            charID: "=charId",
            charDataType: "=",
            entityID: "=entityId"
        }
    };

    return directive;
}

export class RLViewAddAlertToCharacteristicController {
    static $inject = ["$scope", "$q", "$window", "$filter", "notifyService", "alertService", "entityService"];

    charTypeID: number;
    charID: number;
    templateID: number;
    charDataType: number;
    charLabel: string;
    entityID: string;
    recID: number;
    alerts: Models.IAlert[];
    configAlerts: Models.IAlert[];
    recAlerts: Models.IAlert[];

    constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private $filter: ng.IFilterService, private notifyService: NotifyService, private alertService: AlertService, private entityService: EntityService) {
        this.alerts = [];
        this.recAlerts = [];
        this.configAlerts = [];

        $scope.$watchCollection(() => [this.charTypeID, this.templateID, this.charID, this.entityID],
            (newValue, oldValue) => {
                if (this.charTypeID != null && this.templateID != null && this.charID != null && this.entityID != null)
                    this.ParseEntityID(this.entityID);
                this.LoadAlerts();
            });

        $scope.$on('executeAlertsRefresh', () => {
            this.LoadAlerts();
        });
    }

    RequestViewAlerts() {
        this.$scope.$emit('requestViewAlerts');
    }

    RequestAlert() {
        this.$scope.$emit('requestNewAlert');
    }

    LoadAlerts() {
        this.notifyService.startProgress();

        this.alertService.getAlertList(this.charTypeID, this.templateID, this.charID, this.recID)
            .then((results) => {
                this.recAlerts = results;
                this.alertService.getConfigAlertList(this.charTypeID, this.templateID, this.charID, -1)
                    .then((results) => {
                        this.configAlerts = results;
                    })
                    .then(() => {
                        this.alerts = this.recAlerts.concat(this.configAlerts);
                    })
            });

        this.notifyService.endProgress();
    }

    ParseEntityID(entityID) {
        this.recID = Utils.IdBuilder.splitEntityID(entityID).recID;
    }
}